import React from 'react'
import { hooks, I18n } from '@front/volcanion'

import { MapFactory, ModelAutocompleteField } from '@front/squirtle'
import { Button, Grid, Typography, Box, Link, Divider, Icon } from '@mui/material'
import UserUtils from '@front/volcanion/utils/user'
import MapComponent from './Map'
import DispatchErrors from '@abra/elements/Dispatch/Errors'
import DriverComponent from '@abra/elements/Dispatch/Driver'
import moment from 'moment'
const Row1 = props =>
  <Grid size={12}>
    <Typography sx={{ fontSize: 'h6.fontSize', color: 'primary.main', textAlign: 'center', fontWeight: 300 }}>
      {I18n.t('map.manual_dispatch.long')}
    </Typography>
  </Grid>

const Row2 = props =>
  <Grid container justifyContent='center' size={12}>
    <Grid size={8}>
      <ModelAutocompleteField
        name={'user_id'}
        label={I18n.t('map.manual_dispatch.short')}
        model_name={'user'}
        searchMode='search'
        searchQuery={'='}
        autocompleteMutator={q => ({
          or: [
            { info: { user_client_id: { startsWith: _.split(q, ' ') } } },
            { info: { first_name: { startsWith: _.split(q, ' ') } } },
            { info: { last_name: { startsWith: _.split(q, ' ') } } }]
        })}
        labelKeys={['label']}
        multiple={false}
        loadOnFocus={false}
        autoFocus
        config={{
          forced_filter: { driverinfo: { '!': null }, status: [{ name: 'active' }] },
          populate: ['info', 'customerinfo'],
          mutator: user => ({
            label: UserUtils.getFormatedName(
              { ...user?.info, designation: user?.customerinfo?.name },
              { prefix: user?.info?.user_client_id }
            ),
            ...user
          })
        }}
        selectSingleOption
        selectFirst={false}
        required
      />
    </Grid>
  </Grid>

const Row3 = (props) =>
  <Grid size={12}>
    <DriverComponent />
  </Grid>


const Row4 = ({ order_id, driver_id, }) =>
  <Grid size={12}>
    <DispatchErrors order_id={order_id} driver_id={driver_id} />
  </Grid>

const Row5 = ({ canCallDriver, callDriver }) =>
  <Grid hidden={!canCallDriver} size={12}>
    <Button startIcon={<Icon >call</Icon>} onClick={callDriver}>
      {I18n.t('call.driver')}
    </Button>
  </Grid>

const ConflictItem = ({ conflict }) => {
  const [job] = hooks.useModel('job', [conflict?.job_id], { single: true, populate: ['first_step.order.source', 'last_step.order.info', 'last_step.order.destination'] })
  const first_step_order = job?.first_step?.order
  const last_step_order = job?.last_step?.order
  const order_id = first_step_order?.order_id
  const order_client_id = first_step_order?.order_client_id
  const source_name = first_step_order?.source?.name
  const destination_name = last_step_order?.destination?.name
  const source_time = moment(first_step_order?.requestedAt).format('HH:mm')
  const destination_time = moment(last_step_order?.info?.dest_datetime).format('HH:mm')

  return (
    <Box display='flex' flexDirection='column' alignItems='flex-start' gap={1}>
      <Link target='_blank' href={`/order/${order_id}`}>{order_client_id}</Link>
      {conflict.type === 'pickup' && <Typography fontWeight={'bold'}>{I18n.t('order.overlap_dispatch.on_board', { time: source_time })}:</Typography>}
      {conflict.type === 'pickup' && <Typography>{source_name}</Typography>}
      {conflict.type === 'pickup' && <Typography color='red'>{I18n.t(`order.overlap_dispatch.${conflict.type}_late`, { minutes: conflict.late_minutes })}</Typography>}
      {conflict.type === 'dropoff' && <Typography fontWeight={'bold'}>{I18n.t('order.overlap_dispatch.off_board', { time: destination_time })}:</Typography>}
      {conflict.type === 'dropoff' && <Typography>{destination_name}</Typography>}
      {conflict.type === 'dropoff' && <Typography color='red'>{I18n.t(`order.overlap_dispatch.${conflict.type}_late`, { minutes: conflict.late_minutes })}</Typography>}
      <Divider />
    </Box>
  )
}

const ManualDispatch = ({
  order_id,
  user_id,
  canCallDriver,
  callDriver,
  main_source_time,
  main_destination_time,
  conflicts
}) =>
  <Grid container spacing={1} alignItems='flex-start'>
    {!_.isEmpty(conflicts) && (
      <Grid size={4}>
        <Typography>{I18n.t('order.overlap_dispatch.title')}</Typography>
        <Typography>{I18n.t('order.overlap_dispatch.description')}</Typography>
        <Divider />
        <Typography fontWeight={'bold'} marginTop={3}>{I18n.t('order.overlap_dispatch.information_course')}</Typography>
        <Typography marginBottom={3}>
          {I18n.t('order.overlap_dispatch.on_board', { time: main_source_time })} - {I18n.t('order.overlap_dispatch.off_board', { time: main_destination_time })}
        </Typography>
        <Divider />
        <Typography fontWeight={'bold'} marginTop={3}>{I18n.t('order.overlap_dispatch.information_conflict')}</Typography>
        <Box gap={5}>
          {_.map(conflicts, (conflict) => <ConflictItem key={`${conflict.job_id}-${conflict.type}`} conflict={conflict} />)}
        </Box>
      </Grid>
    )}
    <Grid size="grow">
      <MapComponent order_id={order_id} conflicts={conflicts} >
        <MapFactory.LayersControl>
          <MapFactory.ControlBox title={I18n.t('filter.vehicle')} defaultOpen position={'topright'}>
            <Box sx={{ width: 400 }}>
              <Grid container rowSpacing={2} alignItems='center'>
                <Row1 />
                <Row2 />
                <Row3 />
                <Row4 order_id={order_id} driver_id={user_id} />
                <Row5 canCallDriver={canCallDriver} callDriver={callDriver} />
              </Grid>
            </Box>
          </MapFactory.ControlBox>
        </MapFactory.LayersControl>
      </MapComponent>
    </Grid>
  </Grid>
export default React.memo(ManualDispatch)
